// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { deviceId } from './Device';
import { deviceModelConfigParamId } from './DeviceModelConfigParam';
import { z } from 'zod';
export const deviceConfigParamId = (z.number());
export const deviceConfigParam = z.object({
    id: deviceConfigParamId,
    device_id: deviceId,
    key: z.string(),
    type: z.string(),
    label: z.string(),
    unit: z.string().nullable(),
    description: z.string().nullable(),
    group_label: z.string().nullable(),
    min_value: z.number().nullable(),
    max_value: z.number().nullable(),
    default_value: z.unknown().nullable(),
    enum_values: z.unknown().nullable(),
    is_active: z.boolean(),
    last_seen_at: z.date().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    model_config_param_id: deviceModelConfigParamId.nullable(),
});
export const deviceConfigParamInitializer = z.object({
    id: deviceConfigParamId.optional(),
    device_id: deviceId,
    key: z.string(),
    type: z.string(),
    label: z.string(),
    unit: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    group_label: z.string().optional().nullable(),
    min_value: z.number().optional().nullable(),
    max_value: z.number().optional().nullable(),
    default_value: z.unknown().optional().nullable(),
    enum_values: z.unknown().optional().nullable(),
    is_active: z.boolean().optional(),
    last_seen_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    model_config_param_id: deviceModelConfigParamId.optional().nullable(),
});
export const deviceConfigParamMutator = z.object({
    id: deviceConfigParamId.optional(),
    device_id: deviceId.optional(),
    key: z.string().optional(),
    type: z.string().optional(),
    label: z.string().optional(),
    unit: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    group_label: z.string().optional().nullable(),
    min_value: z.number().optional().nullable(),
    max_value: z.number().optional().nullable(),
    default_value: z.unknown().optional().nullable(),
    enum_values: z.unknown().optional().nullable(),
    is_active: z.boolean().optional(),
    last_seen_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    model_config_param_id: deviceModelConfigParamId.optional().nullable(),
});
//# sourceMappingURL=DeviceConfigParam.js.map